const MODAL_TYPE = {
  Suggestion: 'suggestion',
  Login: 'login',
};

export default MODAL_TYPE;
